export default {
	"share.FailedToGetInformation": "獲取信息失敗",
	"share.generatingPoster": "正在生成海報",
	"share.LongPressThePictureToShare": "長按圖片進行分享",
	"share.LimitPrice": "限購價",
	"share.LimitedGift": "限量贈"
}